<ng-container *transloco="let t">
    <mat-card class="altair-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    {{ t("http-status-breakdown") }}
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <apx-chart
                [series]="chartOptions.series!"
                [chart]="chartOptions.chart!"
                [dataLabels]="chartOptions.dataLabels!"
                [plotOptions]="chartOptions.plotOptions!"
                [yaxis]="chartOptions.yaxis!"
                [xaxis]="chartOptions.xaxis!"
                [legend]="chartOptions.legend!"
                [colors]="chartOptions.colors!"
                [grid]="chartOptions.grid!"
            ></apx-chart>
        </mat-card-content>
    </mat-card>
</ng-container>

